import { SELECTED_PROJECT_STORAGE_KEY } from 'utils/storage';

import { useLocalStorageListener } from './useLocalStorageListener';

export const useSelectedProjectId = () => {
  const { setValue, currentValue } = useLocalStorageListener(
    SELECTED_PROJECT_STORAGE_KEY
  );
  return { setSelectedProjectId: setValue, selectedProjectId: currentValue };
};
